module.exports = __webpack_public_path__ + "static/media/icon_system_eye_1.2.426d1c29.svg";